import { isToday } from 'date-fns';
import { TriangleAlert } from 'lucide-react';
import { FC } from 'react';

interface Props {
  skillAssessments:
    | {
        readonly nodes:
          | readonly {
              readonly activityId: string | null | undefined;
              readonly id: string;
              readonly publicUserId: string | null | undefined;
              readonly score: number;
              readonly sessionCompletedOn: string;
              readonly sessionId: string;
              readonly sessionLength: number;
            }[]
          | null
          | undefined;
      }
    | null
    | undefined;
}

export const AssessmentsReportWarning: FC<Props> = ({ skillAssessments }) => {
  const totalAssessments = skillAssessments?.nodes?.length || 1;
  const sumScores = () => {
    let score = 0;
    skillAssessments?.nodes?.forEach(ska => {
      score += ska.score;
    });
    return score * 10;
  };

  return (
    <>
      {skillAssessments?.nodes?.every(ska => ska.score < 8) && skillAssessments.nodes.length > 3 && (
        <div className="tw-bg-red-50 tw-rounded-xl tw-py-2 tw-px-4 tw-flex tw-items-center tw-mb-2">
          <TriangleAlert size={20} color="red" />
          <p className="tw-ml-2">
            <b>+3 failed attempts:</b> {skillAssessments?.nodes?.length} attempts in total,{' '}
            <b>{skillAssessments?.nodes?.filter(ska => isToday(ska.sessionCompletedOn)).length} attempts today</b> with{' '}
            {`${Math.round(sumScores() / totalAssessments)}% `}
            average{' '}
            {`(scores: ${skillAssessments?.nodes
              ?.map(ska => (ska.score > 0 ? `${ska.score}0` : ska.score))
              .join('%, ')}%)`}
            .
          </p>
        </div>
      )}
    </>
  );
};
